import {DocumentUpdateData, DocumentUpdateKey, DocumentUpdateStatusKey} from "../types/document-update.types";
import {DocumentData, Status} from "../types/document-modal.types";
import {defaultDocumentUpdateData} from "../models/document-update-date";

export function isDocumentUpdateDataKey(key: string): key is DocumentUpdateKey {
  return ['contract', 'payment', 'act', 'erid', 'edo', 'oneC'].includes(key);
}

export function isDocumentUpdateStatusKey(key: string): key is DocumentUpdateStatusKey {
  return ['contract', 'payment', 'act', 'edo', 'oneC'].includes(key);
}

export function safeDocumentCopy(source: DocumentData): DocumentUpdateData {
  const result: DocumentUpdateData = { ...defaultDocumentUpdateData };

  (Object.keys(result) as Array<DocumentUpdateKey>).forEach((key) => {
    const sourceValue = source[key];
    const targetFields = result[key];

    if (sourceValue) {
      (Object.keys(targetFields) as Array<keyof typeof targetFields>).forEach((field) => {
        if (field in sourceValue) {
          const sourceFieldValue = sourceValue[field as keyof typeof sourceValue];
          if (sourceFieldValue !== undefined) {
            switch (field) {
              case 'date':
                if (sourceFieldValue instanceof Date) {
                  targetFields[field] = formatDate(sourceFieldValue) as never;
                  break;
                }

                targetFields[field] = sourceFieldValue as never;
                break;
              case 'status':
                targetFields[field] = (sourceFieldValue as Status).currentValue as never;
                break;
              default:
                targetFields[field] = sourceFieldValue as never;
                break;
            }
          }
        }
      });
    }
  });

  return result;
}

function formatDate(date: Date): string {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}
